import React, { PureComponent } from 'react';
import { baseUrl } from '../../../utils/api';
import { translate } from '../../../utils/translations';
import '../Form.css';
import {
    DEFAULT_CONFIG,
    WIDGET_TYPE,
    WIDGET_DIMENSIONS,
    WIDGET_NAMES,
} from '../../../utils/globals';
import Monochrome from '../FormPartials/Monochrome';
import { hasItTooMuchLuminosity } from '../../../utils/utils';

const { widgetType, color } = DEFAULT_CONFIG;

export class FormSimple extends PureComponent {
    state = {
        language: this.props.language,
        widgetType: widgetType,
        color: color,
        colorString: color,
        errorMessageColor: false,
    };

    render() {
        return (
            <div className="FormSimple form" onClick={this.eraseSuggestions}>
                <h2 className="configurador__heading">
                    {translate(this.props.language, 'form_title_main')}
                </h2>
                <hr />
                <form>
                    <h3 className="form__heading">
                        {translate(this.props.language, 'form_title_simple')}
                    </h3>
                    <div className="form__section">
                        <div className="form__item">
                            <label htmlFor="language">
                                {translate(
                                    this.props.language,
                                    'label_language'
                                )}
                            </label>
                            <select
                                name="language"
                                id="language"
                                value={this.state.language}
                                onChange={this.handleChange}
                                className="select-language"
                            >
                                <option value="ca">Català</option>
                                <option value="es">Castellano</option>
                                <option value="en">English</option>
                            </select>
                        </div>
                        <div className="form__item">
                            <label htmlFor="widgetType">
                                {translate(this.props.language, 'label_type')}
                            </label>
                            <select
                                name="widgetType"
                                id="widgetType"
                                value={this.state.widgetType}
                                onChange={this.handleChange}
                                className="select-corporate"
                            >
                                <option value={WIDGET_TYPE.corporate}>
                                    {translate(
                                        this.props.language,
                                        'label_corporate'
                                    )}
                                </option>
                                <option value={WIDGET_TYPE.monochrome}>
                                    {translate(
                                        this.props.language,
                                        'label_monochrome'
                                    )}
                                </option>
                            </select>
                        </div>
                        {this.state.widgetType === WIDGET_TYPE.monochrome && (
                            <Monochrome
                                language={this.props.language}
                                colorString={this.state.colorString}
                                color={this.state.color}
                                handleChange={this.handleChange}
                                errorMessageColor={this.state.errorMessageColor}
                            />
                        )}
                    </div>
                </form>
                <div className="iframeCode">
                    <p className="iframeP">{this.state.iframeCode}</p>
                </div>
            </div>
        );
    }

    componentDidMount() {
        this.generateUrl();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.language !== prevProps.language) {
            this.setState({ language: this.props.language });
        }

        this.generateUrl();

        // Update widget preview
        let key = '';

        if (this.state.color !== prevState.color) key = 'color';
        if (this.state.language !== prevState.language) key = 'language';

        if (key) this.props.updateWidget([key], this.state[key]);
    }

    handleChange = event => {
        const target = event.target;
        const value =
            target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (
            (name === 'color' || name === 'colorString') &&
            hasItTooMuchLuminosity(value)
        ) {
            this.setState({
                color: DEFAULT_CONFIG.color,
                errorMessageColor: true,
            });
            return;
        }

        this.setState({
            [name]: value,
        });

        if (name === 'color') this.setState({ colorString: value });
        if (name === 'colorString') this.setState({ color: value });
        if (name === 'widgetType' && value === WIDGET_TYPE.corporate)
            this.setState({ color: DEFAULT_CONFIG.color });
    };

    generateUrl = () => {
        const { widget } = this.props;
        const { color, language } = this.state;

        const iFrameTitle =
            widget === WIDGET_NAMES.prediccio
                ? translate(language, 'prediccio_title')
                : widget === WIDGET_NAMES.radar
                    ? translate(language, 'radar_title')
                    : translate(language, 'avisos_title');

        const colorTrimmed = color.replace('#', '');

        const checkedBaseUrl = baseUrl ? baseUrl : '';

        const generatedUrl = `${checkedBaseUrl}${widget}?language=${language}&color=${colorTrimmed}`;

        let dimensions = '';
        switch (widget) {
            case 'mapaRadar':
                dimensions = WIDGET_DIMENSIONS.mapaRadar;
                break;
            case 'mapaAvisos':
                dimensions = WIDGET_DIMENSIONS.mapaAvisos;
                break;
            case 'mapaPrediccio':
                dimensions = WIDGET_DIMENSIONS.mapaPrediccio;
                break;
            default:
                dimensions = WIDGET_DIMENSIONS.default;
        }

        const iframeCode = `<iframe src="${generatedUrl}" title="${iFrameTitle}"
        frameborder="0" style="border:0" scrolling="no" width="${
            dimensions.width
        }" height="${dimensions.height}"></iframe>`;
        this.setState({ widgetUrl: generatedUrl, iframeCode });
    };
}



// WEBPACK FOOTER //
// ./src/containers/Configurador/FormSimple/FormSimple.js